<template>
    <grant-sub-wizard>
        <grant-sub-wizard-tab>
            <form>
                <div class="row mt-3">
                    <div class="col-lg-8">
                        <!-- Upload budget -->
                        <div class="file-form-group row ml-0 mr-0 mb-3">
                            <div class="col-9 d-flex flex-column justify-content-center">
                                <p class="file-caption">{{ $t('proposals.field_title__upload_budget') }}</p>
                                <label v-if="getError('budget.document')" class="error text-danger">{{ getError('budget.document') }}</label>
                            </div>
                            <div class="col-3 d-flex justify-content-center align-items-center">
                                <upload-file
                                    v-model="CallForm.files.budget.document"
                                    class="upload-file"
                                    section="budget.document"
                                    name="budget.document"
                                    model-name="Proposal"
                                    v-validate.persist="'required'"
                                    :data-vv-as="$t('proposals.field_title__upload_budget')"
                                    :is-editable="CallForm.isFPEditable"
                                    :file-data="CallForm.files.budget.document"
                                    :allowed-file-type="'xls|xlsx'"
                                >
                                </upload-file>
                            </div>
                        </div>

                        <a :href="fullProposalTemplate[$i18n.locale]" target="_blank" class="ml-2 btn btn-simple btn-primary">
                            {{ $t('proposals.button_title__download_budget_template' )}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
                        </a>

                        <!-- Upload additional budget documents -->
                        <div class="file-form-group row ml-0 mr-0 mt-5">
                            <div class="file-inner-group row ml-0 mr-0" v-for="(item, index) in CallForm.model.budget.budget_documents">
                                <div class="col-6 d-flex flex-column justify-content-center">
                                    <textarea
                                        class="form-control"
                                        v-model="item.title"
                                        :placeholder="$t('general.general__insert_name')"
                                        >
                                    </textarea>
                                </div>
                                <div class="col-3 d-flex justify-content-center align-items-center">
                                    <upload-file
                                        v-model="CallForm.files.budget['budget_documents' + (index + 1)]"
                                        class="upload-file"
                                        :section="'budget.budget_documents' + (index + 1)"
                                        model-name="Proposal"
                                        :file-data="CallForm.files.budget['budget_documents' + (index + 1)]"
                                        :is-editable="CallForm.isFPEditable"
                                    >
                                    </upload-file>
                                </div>
                            </div>
                            <base-button
                                type="primary"
                                size="lg"
                                @click.native="addOtherDocument('budget_documents')"
                                class="btn-fill btn-add-new-document">
                                {{ $t('proposals.button_title__add_document') }}
                            </base-button>
                        </div>

                    </div>
                </div>
            </form>
        </grant-sub-wizard-tab>
    </grant-sub-wizard>
</template>
<script>
import Multiselect from 'vue-multiselect';
import { CallForm } from "@/services";
import {GrantSubWizard, GrantSubWizardTab} from '@/components';

export default
{
    components:
    {
        Multiselect,
        GrantSubWizard,
        GrantSubWizardTab,
    },
    data()
    {
        return {
            CallForm,
            fullProposalTemplate:
            {
                en: '/files/en/2020/LIFE4BEST-ORs-2020_SSG_Budget_Template_EN.xls',
                fr: '/files/fr/2020/LIFE4BEST_Budget_Fichier_FR.xls',
            },
        }
    },
    methods:
    {
        addOtherDocument(fieldName)
        {
            if (!CallForm.model.budget[fieldName])
            {
                CallForm.model.budget[fieldName] = [];
            }

            CallForm.model.budget[fieldName].push({
                title: '',
            });

            this.$forceUpdate();
        },
        getError(fieldName)
        {
            return this.errors.first(fieldName);
        },
        validate()
        {
            return this.$validator.validateAll().then(res => {
                this.$emit('on-validated', res, this.model);
                return res;
            });
        },
    },
}
</script>
<style lang="scss" scoped>
    a
    {
        color: black;

        &:hover
        {
            text-decoration: underline;
        }
    }

    .file-form-group
    {
        padding: 0.625rem 0;
        border: 1px solid #24a46d;
        border-radius: 10px;
    }

    .file-caption
    {
        // font-weight: 500;
    }

    .file-subcaption
    {
        font-size: 0.775rem;
    }

    .btn-add-new-document
    {
        margin-top: 1.25rem;
        margin-right: 15px;
        margin-left: 15px;
        width: 100%;
    }

    .count-titles
    {
        counter-reset: cardTitles;

        h4.card-title
        {
            margin-top: 10px;
            counter-increment: cardTitles;

            &:before
            {
                content: counter(cardTitles) '. ';
            }

            .fa-question
            {
                margin-left: 10px;
                display: inline-block;
                width: 24px;
                height: 24px;
                font-size: 13px;
                line-height: 24px;
                text-align: center;
                color: #fff;
                border-radius: 100%;
                background-color: #2083f7;
            }
        }
    }

    .table-bordered th,
    .table-bordered td
    {
        padding: 5px;
    }
</style>
